/**
 * Kentucky settlements that show up on the Project Zomboid map.
 * Used as the source of truth for the "Last Seen" dropdown on member profiles.
 */
export const KENTUCKY_LOCATIONS = [
  "Muldraugh",
  "Riverside",
  "Rosewood",
  "West Point",
  "Valley Station",
  "Louisville",
  "March Ridge",
  "Dixie Mobile Park",
  "Scenic Grove Mobile Home Park",
  "Fallas Lake",
  "Coalfield",
  "Echo Creek",
  "Brandenburg",
  "Ekron",
  "Irvington",
];
